import React from 'react';
import { Grain, Letterbox, Halo, useScrollProgress, ChapterMark, FadeIn } from './BasicUI';
import { useActiveYuga } from '../../hooks/useActiveYuga';
import { OmDrone } from './OmDrone';
import { YugaWheelSVG } from './YugaWheelSVG';
import { GranthalayaToggle } from '../scriptures/Granthalaya';

export function HUD({ yuga, chapterLabel, progress }) {
  return (
    <>
      <div className="hud" aria-hidden="true">
        <div className="yuga-wheel"><YugaWheelSVG stage={yuga} /></div>
        <div className="chapter-ticker">
          <span className="now">{chapterLabel}</span>
          <span>{yuga.toUpperCase()} YUGA</span>
          <div className="progress"><i style={{ width: `${(progress * 100).toFixed(1)}%` }} /></div>
        </div>
      </div>
      <div className="hud-right">
        <GranthalayaToggle />
        <OmDrone />
      </div>
    </>
  );
}

export function AppShell() {
  const { yuga, chapter } = useActiveYuga();
  const progress = useScrollProgress();

  return { yuga, chapter, progress };
}

export { Grain, Letterbox, Halo, useScrollProgress, ChapterMark, FadeIn };
